// @flow
import React from 'react';
import SMSocialFacebookLink from 'components/social/SMSocialFacebookLink';
import SMSocialLineLink from 'components/social/SMSocialLineLink';
import SMSocialTwitterLink from 'components/social/SMSocialTwitterLink';
import SMAppHelper from 'components/helpers/SMAppHelper';
import sprintf from 'sprintf';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMCopyText from 'components/social/SMCopyText';

class SMReferralView extends React.Component {

  renderReferralShareComponent(isHero: boolean) {
    const user = this.props.currentUser;
    const loginUrl = this.props.login_url;
    const shareUrl = loginUrl + "?referred_by=" + user.referral_token;
    const bodyForTwitter = "下記のURLから新規会員登録で2,000円分のポイントプレゼント！ 撮影会やパーティー、会議などのレンタルスペースを簡単予約｜スペースマーケット";
    const subjectForLine = "スペースマーケットへの招待が届きました。下記のURLから新規会員登録で2,000ポイントプレゼント！";

    let heroShareClass = '';
    if (isHero) {
      heroShareClass = 'referral__urlcontents-share heroimg-share';
    } else {
      heroShareClass = 'referral__urlcontents-share';
    }

    return (
      <div className="referral__urlcontents">
        <div className="row">
          <div className="col-xs-12">
            <SMCopyText url={shareUrl} gaLabel="referral copy"></SMCopyText>
          </div>
        </div>
        <p className="referral__urlcontents-caution">※ポイント有効期限・獲得条件があります。注意事項をよくお読みください。</p>
        <div className={heroShareClass}>
          <p className="referral__urlcontents-sharetext">URLをシェアする</p>
          <ul className="row referral__social">
            <li className="col-xs-4">
              <SMSocialLineLink subject={subjectForLine} body={shareUrl} gaLabel="referral line" />
            </li>
            <li className="col-xs-4">
              <SMSocialTwitterLink url={shareUrl} body={bodyForTwitter} gaLabel="referral twitter" />
            </li>
            <li className="col-xs-4">
              <SMSocialFacebookLink url={shareUrl} gaLabel="referral facebook" />
            </li>
          </ul>
        </div>
      </div>
    );
  }

  didClickPointHistory() {
    SMAppHelper.redirectTo(Routes.dashboard_points_pending_point_histories_path());
  }

  render() {

    return (
      <div className="site-main">

        <div className="mod-heroimg referral__bg">
          <img src={SMRailsBridge.assetPath.referralHeroManyspace} alt="友だち招待" className="mod-heroimg__img" />
          <div className="mod-heroimg__bg referral__bg">
            <div className="mod-heroimg__contents">
              <h1 className="referral__title">
                友だちを招待して<br />ポイントを貯めよう
              </h1>
              <div className="referral__ribbon">
                <span className="referral__ribbon-inner">
                  <span className="referral__ribbon-text">それぞれに
                    <span className="referral__ribbon-bigtext">2,000</span>ポイントプレゼント！
                  </span>
                </span>
              </div>
              <p className="referral__heroimg-text pc-hide__xs-show">
                下記のURLから友だちが<br />
                新規会員登録してスペースを利用すると、<br />
                あなたと友だちそれぞれに<br />
                スペースマーケットで使える<br />
                2,000円分のポイントをプレゼント！
              </p>
              <p className="referral__heroimg-text xs-hide">
                下記のURLから友だちが新規会員登録してスペースを利用すると、<br />
                あなたと友だちそれぞれにスペースマーケットで使える2,000円分のポイントをプレゼント！
              </p>

              {this.renderReferralShareComponent(true)}
            </div>
          </div>
        </div>

        <div className="page__odd referral">
          <div className="container">
            <h2 className="referral__content-title">ポイント取得までの流れ</h2>
            <div className="row referral__step">
              <div className="col-md-3 referral__step-wrap">
                <div className="referral__step-list">
                  <div className="referral__step-list-img">
                    <img src={SMRailsBridge.assetPath.referralFlowRequest} alt="URLを送る" />
                  </div>
                  <p className="referral__step-list-text">まだスペースマーケットに登録していない友だちに招待URLを送ります。</p>
                </div>
              </div>
              <div className="col-md-3 referral__step-wrap">
                <div className="referral__step-list">
                  <div className="referral__step-list-img">
                    <img src={SMRailsBridge.assetPath.referralFlowPropriety} alt="会員登録" />
                  </div>
                  <p className="referral__step-list-text">友だちに招待URLより会員登録をしてもらいます。</p>
                </div>
              </div>
              <div className="col-md-3 referral__step-wrap">
                <div className="referral__step-list">
                  <div className="referral__step-list-img">
                    <img src={SMRailsBridge.assetPath.referralFlowDone} alt="会員登録完了" />
                  </div>
                  <p className="referral__step-list-text">会員登録が完了すると、紹介した友だちに2,000ポイントが付与されます。</p>
                </div>
              </div>
              <div className="col-md-3 referral__step-wrap">
                <div className="referral__step-list">
                  <div className="referral__step-list-img">
                    <img src={SMRailsBridge.assetPath.referralFlowFix} alt="ポイントが付与" />
                  </div>
                  <p className="referral__step-list-text">友だちがスペースを利用すると、あなたに2,000円分の紹介ポイントが付与されます。</p>
                </div>
              </div>
            </div>

            <div className="referral__notes">
              <dl className="inquiry-uses__notes">
                <dt>注意事項</dt>
                <dd>
                  <ul className="inquiry-uses__notes-list">
                    <li>招待をうける方が初めてスペースマーケットをご利用になる場合のみ対象です。</li>
                    <li>招待をうけた方が新規会員登録で取得したポイント、招待者が取得したポイントの<span className="bold">有効期限はともに3ヶ月</span>です。</li>
                    <li>招待をうけた方のスペース利用金額が<span className="bold">10,000円以上だった場合のみ</span>、招待者に2,000円分の招待ポイントが付与されます。</li>
                    <li>招待をうけた方が予約完了（成約）した時点で、招待者に2,000円分の招待ポイントが獲得予定ポイントとして加算されます。</li>
                    <li>予約リクエスト後、<span className="bold">キャンセルや否認、また金額が10,000円未満になった場合、招待者の獲得予定ポイントは失効</span>します。</li>
                    <li>招待を受けた方が<span className="bold">スペースを利用した日から1週間後</span>に、招待者の獲得予定ポイント2,000ポイントが確定し、使用可能となります。</li>
                    <li>招待者が獲得した2,000ポイントの有効期間は、ポイント確定した日から3ヶ月間です。</li>
                    <li>招待者が招待によりもらえるポイントの上限は10万ポイントです。</li>
                  </ul>
                </dd>
              </dl>
            </div>
            <p className="button-blue pt15 pb15 w250 mb15" onClick={this.didClickPointHistory}>
              ポイント獲得履歴を見る
            </p>
          </div>
        </div>

        <div className="page__even">
          {this.renderReferralShareComponent(false)}
        </div>
      </div>
    );
  }
}
export default SMReferralView;




// WEBPACK FOOTER //
// ./app/javascript/components/referrals/SMReferralView.jsx